import {
  GET_TENANT,
  GET_TENANT_SUCCESS,
  GET_TENANT_ERROR,
  DELETE_TENANT,
  DELETE_TENANT_SUCCESS,
  DELETE_TENANT_ERROR,
} from "../actions";

export const getTenant = (tenantName, activityInfo) => ({
  type: GET_TENANT,
  payload: { tenantName, activityInfo },
});

export const getTenantSuccess = (tenant) => ({
  type: GET_TENANT_SUCCESS,
  payload: tenant,
});

export const getTenantError = (message) => ({
  type: GET_TENANT_ERROR,
  payload: { message },
});

export const trashTenant = (tenantName) => ({
  type: DELETE_TENANT,
  payload: { tenantName },
});

export const trashTenantSuccess = (successMessage) => ({
  type: DELETE_TENANT_SUCCESS,
  payload: { successMessage },
});

export const trashTenantError = (message) => ({
  type: DELETE_TENANT_ERROR,
  payload: { message },
});
